import _regeneratorRuntime from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.string.substr.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.push.js";
import { localStorage, setTimeLocalStorage } from '@/store/storage';
import moment from 'moment';
import Signin from '@/api/modules/signin';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import { AUTION } from '@/config/parameters.js';
import { copyText } from '@/utils/utils';
import { getFavoriteCount } from '@/utils/utils';
import { getBalance, walletConnectDisAble } from '@/utils/connect';
import { getChainImages, getChainList } from '@/utils/chainInfo';
import Empty from '@/components/common/empty';
import CopyBtn from '@/components/copyBtn/copyBtn.vue';
import Email from '@/api/modules/email';
import Domain from '@/api/modules/domain';
import MyTld from '@/api/modules/myTld';
import { ethers } from 'ethers';
import gasNumber from '@/components/gasNumber/index.vue';
import { defaultAvatar } from '@/utils/resource';
export default {
  name: 'userInfo',
  props: {
    drawerShow: {
      modelValue: Boolean
    }
  },
  components: {
    gasNumber: gasNumber,
    Empty: Empty,
    CopyBtn: CopyBtn
  },
  data: function data() {
    return {
      loading: false,
      startX: 0,
      startY: 0,
      endX: 0,
      endY: 0,
      userinfo: {
        email: ''
      },
      couponNum: 0,
      settedDomain: '',
      domainTotal: 0,
      tldTotal: 0,
      vantShow: false,
      balance: null,
      dollar: null
    };
  },
  watch: {
    account: {
      handler: function handler(to, from) {
        if (to) {
          this.init();
        } else {
          this.loading = false;
          this.userinfo = {
            email: ''
          };
          this.couponNum = 0;
          this.settedDomain = '';
          this.domainTotal = 0;
        }
      },
      deep: true,
      immediate: false
    },
    drawerShow: {
      handler: function handler(to, from) {
        var _this = this;
        if (to) {
          this.vantShow = this.drawerShow;
          this.init();
        } else {
          setTimeout(function () {
            _this.loading = false;
            _this.userinfo = {
              email: ''
            };
            _this.couponNum = 0;
            _this.settedDomain = '';
            _this.domainTotal = 0;
          }, 1000);
          this.vantShow = false;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: _objectSpread({
    isMobile: function isMobile() {
      return this.$store.state.isMobile;
    },
    headerImg: function headerImg() {
      return defaultAvatar();
    },
    chainImg: function chainImg() {
      var chainImg = getChainImages();
      return chainImg[this.chainid];
    },
    chainName: function chainName() {
      if (this.chainid) {
        var chainInfo = getChainList();
        if (chainInfo[this.chainid]) {
          return chainInfo[this.chainid].chainName;
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
    linkArr: function linkArr() {
      return [{
        title: this.$t('userInfo.my_domain'),
        url: '/myName',
        name: '',
        key: '0',
        icon: require('@/assets/image/userinfo/my_domain.png')
      }, {
        title: this.$t('userInfo.my_tld'),
        url: '/myTld',
        name: '',
        key: '5',
        icon: require('@/assets/image/userinfo/my_tld.png')
      }, {
        title: this.$t('userInfo.my_collection'),
        url: '/favorite',
        name: '',
        key: '1',
        icon: require('@/assets/image/userinfo/coolect.png')
      }, {
        title: this.$t('userInfo.my_coupon'),
        url: '/coupon',
        name: '',
        key: '2',
        icon: require('@/assets/image/userinfo/coupon.png')
      }, {
        title: this.$t('userInfo.operation_record'),
        url: '/operationRecord',
        name: '',
        key: '3',
        icon: require('@/assets/image/userinfo/icon_Operation_record.svg')
      }, {
        title: this.$t('userInfo.my_email'),
        url: '',
        name: '',
        key: '4',
        icon: require('@/assets/image/userinfo/my_email.png'),
        un_skip: true
      }];
    },
    primtyName: function primtyName() {
      if (this.settedDomain && this.settedDomain.length > 19) {
        return this.settedDomain.substr(0, 8) + '...' + this.settedDomain.substr(this.settedDomain.length - 8, 8);
      } else {
        return this.settedDomain;
      }
    },
    accounts: function accounts() {
      return this.$store.state.account ? this.$getAbbreviateAddress(this.$store.state.account) : this.$t("header.connect");
    }
  }, mapState(['chainid', 'account', 'accessToken'])),
  mounted: function mounted() {},
  methods: {
    getTokenBalance: function getTokenBalance() {
      var _this2 = this;
      getBalance().then(function (res) {
        _this2.balance = res.balance;
        _this2.dollar = res.usd;
      })["catch"](function (err) {
        //console.log('getBalance.err==', err)
      });
    },
    handleTouchstart: function handleTouchstart(e) {
      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;
    },
    handleTouchend: function handleTouchend(e) {
      this.endX = e.touches[0].clientX;
      this.endY = e.touches[0].clientY;
      if (this.startX - this.endX <= -100 && this.startY - this.endY <= 50) {
        // 右滑触发
        this.$emit('handHideCard');
      }
    },
    getCoupon: function getCoupon() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var json, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              json = {
                pageNo: 1,
                pageSize: 1,
                status: 1
              };
              _context.next = 4;
              return Signin.getCouponsList(json);
            case 4:
              res = _context.sent;
              _this3.couponNum = res.total;
              _this3.loading = false;
              _context.next = 11;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9]]);
      }))();
    },
    getDomainList: function getDomainList() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var json, domain, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              json = {
                pageNo: 1,
                pageSize: 1,
                chainIds: '-1',
                privFlag: '',
                name: ''
              };
              _context2.prev = 1;
              _context2.next = 4;
              return Domain.getDomainList(json);
            case 4:
              domain = _context2.sent;
              _this4.domainTotal = domain.total;
              _context2.next = 8;
              return MyTld.getTldList(json);
            case 8:
              data = _context2.sent;
              _this4.tldTotal = data.total;
              _context2.next = 14;
              break;
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](1);
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 12]]);
      }))();
    },
    settingEmail: function settingEmail(e) {
      this.$emit('settingEmail', e, 1);
    },
    init: function init() {
      this.loading = true;
      if (!this.account) {
        this.loading = false;
        return;
      }
      this.getTokenBalance();
      this.setRemain();
      this.getCoupon();
      this.getReverse();
      this.getDomainList();
      getFavoriteCount();
    },
    setRemain: function setRemain() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var json, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              json = {
                bizType: 1
              };
              _context3.prev = 1;
              _context3.next = 4;
              return Email.getEmailReminder(json);
            case 4:
              res = _context3.sent;
              console.log(res);
              _this5.userinfo = res;
              localStorage.setItem('emailList', JSON.stringify(res));
              _context3.next = 12;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](1);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 10]]);
      }))();
    },
    getReverse: function getReverse() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              try {
                _this6.$getSUID().getReverse(_this6.account, _this6.chainid).then(function (res) {
                  _this6.settedDomain = res;
                })["catch"](function (err) {
                  //console.log("getReverse.err:", err);
                });
              } catch (error) {
                //console.log(error)
              }
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    handleSetDomain: function handleSetDomain() {
      this.handleClosesBox();
      this.$router.push('/setPrimaryName');
    },
    handleClosesBox: function handleClosesBox() {
      this.$emit('handHideCard');
    },
    handleChangeChainId: function handleChangeChainId() {
      this.handleClosesBox();
      this.$emit('handleChangeChainId');
    },
    handleSkip: function handleSkip(url, item) {
      if (item.un_skip) {
        if (this.userinfo.email && this.userinfo.email != 'null' && this.userinfo.email != null) {
          this.settingEmail(3);
        } else {
          this.settingEmail(2);
        }
      } else {
        if (url) {
          this.handleClosesBox();
          this.$router.push(url);
        }
      }

      // settingEmail
    },
    handLoginOut: function handLoginOut() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              localStorage.removeItem('token');
              sessionStorage.removeItem('account');
              _this7.$store.commit('setAccount', '');
              _this7.$store.commit('setAccessToken', '');
              _this7.$store.commit('setPrimaryName', '');
              walletConnectDisAble();
              _this7.handleClosesBox();
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    handCopy: function handCopy(e) {
      try {
        copyText(e);
      } catch (error) {
        //console.log(error);
      }
    }
  }
};